import { useContext } from 'react';
import { Typography } from '@arionbanki/arionui';
import { AppContext } from 'providers/AppProvider';

type RiskqTitleProps = Readonly<{
	isLastPage: boolean;
	prefix: string;
	testType: string;
}>;

export function RiskqTitle(props: RiskqTitleProps) {
	const { t } = useContext(AppContext);
	const { isLastPage, prefix, testType } = props;
	const titleKey = isLastPage ? `${testType}_derivatives_title` : `${prefix}_title`;
	return (
		<Typography TagName="h3" className="mb-5 text-uppercase">
			{t(titleKey, 'riskq')}
		</Typography>
	);
}
